import {Component,OnInit} from "@angular/core";
import {ParamsCartes} from "@domain/admin/frais/cartes/params-cartes";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ParamsCartesService} from "@services/admin/frais/params-cartes.service";
import {handleResult} from "@share/utils/handle-result";

/**
 * Onglet ndf frais cartes
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'ndf-frais-cartes'},
    templateUrl: './ndf-frais-cartes.component.html'
})
export class NdfFraisCartesComponent implements OnInit {
    /** Paramètres des frais cartes */
    paramsCartes: ParamsCartes;

    /** Liste des actions possibles pour le floatingButton en bas à droite */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(private translateService: TranslateService,
                private toastrService: ToastrService,
                private paramsCartesService: ParamsCartesService) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Récupération des paramètres
        this.paramsCartesService.loadParams().subscribe((result) => {
            //Chargement des paramètres dans la variable locale
            this.paramsCartes = new ParamsCartes(result.data?.params);
        });

        //Définition de la liste des actions
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-sauvegarde',
            libelle: 'global.actions.enregistrer',
            doAction: () => this.save()
        }]);
    }

    /**
     * Sauvegarde des paramètres
     */
    save() {
        //Enregistrement des paramètres
        this.paramsCartesService.saveParams(this.paramsCartes)
            .pipe(handleResult(this.translateService,this.toastrService,
                'global.success.enregistrement','global.errors.enregistrement'))
            .subscribe();
    }

    /**
     * Lors du changement de la case à cocher antiDoublonInterLot
     */
    onChangeAntiDoublonInterLot() {
        //Sortie du cycle standard pour forcer la prise en compte du nouveau statut du booléen
        setTimeout(() => {
            //Si le booléen antiDoublonInterLot est à false
            if (!this.paramsCartes?.antiDoublonInterLot) {
                //On met à false les autres booléens
                this.paramsCartes.antiDoublonIntraLot = false;
                this.paramsCartes.antiDoublonIntraFichier = false;
            }
        });
    }

    /**
     * Lors du changement de la case à cocher antiDoublonIntraLot
     */
    onChangeAntiDoublonIntraLot() {
        //Sortie du cycle standard pour forcer la prise en compte du nouveau statut du booléen
        setTimeout(() => {
            //Si le booléen antiDoublonIntraLot est à false
            if (!this.paramsCartes?.antiDoublonIntraLot) {
                //On met à false le dernier booléen
                this.paramsCartes.antiDoublonIntraFichier = false;
            }
        });
    }
}
